export const state = () => ({
    globalId: '',
    permId: '',
    isSimpleMode: false,
    generalErrors: [],
    generalSuccesses: [],
    clientIp: null,
    is404: false,
})

export const mutations = {
    setClientIp(state, ip) {
        state.clientIp = ip
    },
    setGlobalId(state, globalId) {
        state.globalId = globalId
    },
    addGeneralError(state, error) {
        /**
         * NOTE: When we get bugsnag or something we need
         * to log any errors that get this far and are not
         * formatted how Explode.vue wants them so we can
         * track them down and get them fixed.
         */
        state.generalErrors.push(error)
    },
    clearGeneralErrors(state) {
        state.generalErrors = []
    },
    addGeneralSuccess(state, success) {
        state.generalSuccesses.push(success)
    },
    clearGeneralSuccesses(state) {
        state.generalSuccesses = []
    },
    setSimpleMode(state, data) {
        state.isSimpleMode = data
    },
    setIs404(state, is404) {
        state.is404 = is404
    },
    setPermId(state, permId) {
        state.permId = permId
    },
}

export const actions = {
    setGlobalId({ state, commit }) {
        this.$axios
            .get(`${this.$config.platform.apis.globalId}?permId=${state.permId}`, {
                withCredentials: true,
                progress: false,
            })
            .then((response) => {
                const { globalId } = response.data
                commit('setGlobalId', globalId)
            })
    },
    addGeneralError({ commit }, error) {
        commit('addGeneralError', error)
    },
    clearGeneralErrors({ commit }) {
        commit('clearGeneralErrors')
    },
    addGeneralSuccess({ commit }, success) {
        commit('addGeneralSuccess', success)
    },
    clearGeneralSuccesses({ commit }) {
        commit('clearGeneralSuccesses')
    },
    setSimpleMode({ commit }, bool) {
        commit('setSimpleMode', bool)
    },
}
